var map = {
	"./Facebook.svg": "0RnZ",
	"./Heart.svg": "Ukaw",
	"./Instagram.svg": "4laX",
	"./Location.svg": "hOR3",
	"./Login.svg": "uj7m",
	"./LogoColor.svg": "GQul",
	"./LogoWhite.svg": "/DxR",
	"./NextArrow.svg": "70Gy",
	"./Phone.svg": "/VDe",
	"./PrevArrow.svg": "GHFA",
	"./Quotes.svg": "zFPm",
	"./Quotes1.svg": "i9lL",
	"./Referral.svg": "1bf+",
	"./Triangle.svg": "RTsH",
	"./arrow.svg": "7Hhe",
	"./svg.svg": "8viG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "UFRR";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons ^\.\/.*\.svg$
// module id = UFRR
// module chunks = 1